import React from "react";
import { Stepper, Step, StepLabel, Paper } from "@mui/material";
import { useTheme } from "@mui/material/styles";

const StepperComponent = ({ steps, activeStep }) => {
  const theme = useTheme();
  
  return (
    <Paper
      elevation={3}
      sx={{
        p: { xs: 2, sm: 3 },
        backgroundColor: theme.palette.mode === 'dark'
          ? 'rgba(255,255,255,0.05)'
          : 'rgba(255,255,255,0.9)',
        borderRadius: 3,
        backdropFilter: 'blur(10px)',
        border: '1px solid',
        borderColor: theme.palette.mode === 'dark'
          ? 'rgba(255,255,255,0.1)'
          : 'rgba(0,0,0,0.1)',
        maxWidth: { xs: '100%', sm: '500px', md: '900px', lg: '1000px' },
        width: '100%',
        mx: 'auto'
      }}
    >
      <Stepper
        activeStep={activeStep}
        alternativeLabel
        sx={{
          '& .MuiStepLabel-label': {
            color: 'text.primary',
            fontSize: { xs: '0.875rem', sm: '1rem' },
            fontWeight: 500
          },
          '& .MuiStepIcon-root.Mui-active': {
            color: 'primary.main'
          },
          '& .MuiStepIcon-root.Mui-completed': {
            color: 'primary.main'
          },
          '& .MuiStepConnector-line': {
            borderColor: 'primary.main'
          },
          '& .MuiStepIcon-root': {
            fontSize: { xs: '1.5rem', sm: '2rem' }
          }
        }}
      >
        {steps.map((label) => (
          <Step key={label}>
            <StepLabel>{label}</StepLabel>
          </Step>
        ))}
      </Stepper>
    </Paper>
  );
};

export default StepperComponent;